import { Label } from "@/components/ui/label";
import { InputDecimal } from "@/components/ui/input-decimal";

import Secao from "./Secao";

const brl = (v) => `R$ ${v.toFixed(2).replace(".", ",")}`;

/** Perda no preparo, com o efeito no custo dito em uma frase. */
export default function SecaoPerda({ numero = 5, lossPercent, setLossPercent, idPrefix = "" }) {
  const p = Number(lossPercent) || 0;
  const valido = p > 0 && p < 100;
  return (
    <Secao numero={numero} titulo="Perda no preparo" ajuda="Quanto do item vai fora na limpeza ou no preparo. Opcional." testId="secao-perda">
      <div className="flex items-center gap-3">
        <div className="w-32">
          <InputDecimal id={`${idPrefix}lossPercent`} decimals={2} sufixo="%" value={lossPercent} onChange={setLossPercent} className="h-10" />
        </div>
        <Label htmlFor={`${idPrefix}lossPercent`} className="text-xs text-muted-foreground font-normal leading-snug" data-e2e="efeito-perda">
          {valido
            ? <>Com {p.toFixed(2).replace(".", ",")}% de perda, {brl(10)} de compra viram <strong className="text-foreground">{brl(10 / (1 - p / 100))}</strong> de custo.</>
            : <>Ex.: com 33% de perda, R$ 10,00 de compra viram <strong className="text-foreground">R$ 15,00</strong> de custo.</>}
        </Label>
      </div>
    </Secao>
  );
}
